import React from "react";
import { PlMetricCard } from "./PlMetricCard";
import { PlMetricCardSkeleton } from "./PlMetricCardSkeleton";
import { PlSummaryInsights } from "./PlSummaryInsights";

export interface PlSummaryMetrics {
  /** From API `ytd_subtext`, e.g. "Apr 2024 – Mar 2025"; shown on the line below each card title. */
  ytdRangeSubtext: string;
  ytdRevenue: {
    value: string;
    changeText: string;
    changeVariant: "success" | "error" | "neutral";
    subtext: string;
  };
  ytdEbitda: {
    value: string;
    changeText: string;
    changeVariant: "success" | "error" | "neutral";
    subtext: string;
  };
  ebitdaMargin: {
    value: string;
    changeText: string;
    changeVariant: "success" | "error" | "neutral";
    subtext: string;
  };
  pat: {
    value: string;
    changeText: string;
    changeVariant: "success" | "error" | "neutral";
    subtext: string;
  };
}

export interface PlSummarySectionProps {
  loading?: boolean;
  metrics: PlSummaryMetrics;
}

export function PlSummarySection({
  loading = false,
  metrics,
}: PlSummarySectionProps) {
  const rangeSubtext = metrics.ytdRangeSubtext?.trim() || undefined;

  return (
    <div className="flex w-full flex-col gap-4 items-stretch">
      <div className="flex w-full items-start gap-4 mobile:flex-col">
        {loading ? (
          <>
            <PlMetricCardSkeleton />
            <PlMetricCardSkeleton />
            <PlMetricCardSkeleton />
            <PlMetricCardSkeleton />
          </>
        ) : (
          <>
            <PlMetricCard
              label="FY Revenue"
              labelRangeSubtext={rangeSubtext}
              value={metrics.ytdRevenue.value}
              icon="trendingUp"
              changeText={metrics.ytdRevenue.changeText}
              changeVariant={metrics.ytdRevenue.changeVariant}
              subtext={metrics.ytdRevenue.subtext}
            />
            <PlMetricCard
              label="FY EBITDA"
              labelRangeSubtext={rangeSubtext}
              value={metrics.ytdEbitda.value}
              icon="trendingDown"
              changeText={metrics.ytdEbitda.changeText}
              changeVariant={metrics.ytdEbitda.changeVariant}
              subtext={metrics.ytdEbitda.subtext}
            />
            <PlMetricCard
              label="EBITDA Margin"
              labelRangeSubtext={rangeSubtext}
              value={metrics.ebitdaMargin.value}
              icon="pieChart"
              changeText={metrics.ebitdaMargin.changeText}
              changeVariant={metrics.ebitdaMargin.changeVariant}
              subtext={metrics.ebitdaMargin.subtext}
            />
            <PlMetricCard
              label="PAT"
              labelRangeSubtext={rangeSubtext}
              value={metrics.pat.value}
              icon="trendingUp"
              changeText={metrics.pat.changeText}
              changeVariant={metrics.pat.changeVariant}
              subtext={metrics.pat.subtext}
            />
          </>
        )}
      </div>

      <PlSummaryInsights />
    </div>
  );
}
